import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setMapTile } from '@/utils/util.js';
import companyImg from '@/assets/others/map/company.png';
var rangingTool;
var map;
var mouseTool;
var placeSearch;
import tab from "./com/testTab.vue";
import { siteCompanyList, queryWastDateList, queryDateSkylist, queryDateSkyRealTime, queryAreaInfo, queryPipeSystem, queryManholeCover, ajaxGetDictItems } from '@/api/api';
import analysis from '@/components/env-bigData/analysis';
import { getAction } from '@/api/manage';
import { commonRender } from '@/mixins/commonRender';
import mapLegend from "./com/mapLegend.vue";
import projectInfo from "./com/projectInfo.vue";
export default {
  components: {
    analysis: analysis,
    tab: tab,
    mapLegend: mapLegend,
    projectInfo: projectInfo
  },
  mixins: [commonRender],
  data: function data() {
    return {
      showContent: false,
      showMarkerLabel: true,
      infoWindows: [],
      searchValue: '',
      state: false,
      location: '',
      adcode: '',
      adname: '',
      showContens: false,
      showTab: false,
      value: '',
      showClose: false,
      showState: false,
      mesureState: false,
      arr: [],
      plugin: [{
        defaultType: 0,
        showRoad: false,
        showTraffic: false
      }],
      imgUrl: require('@/assets/others/index/bg.gif'),
      wrongUrl: require('@/assets/others/index/wrong.png'),
      map: null,
      showDrawer: false,
      heatmap: null,
      showIt: false,
      standList: [],
      markerList: [],
      showLeft: false,
      companyDetail: {},
      timer: '',
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      wellImg: require('@/assets/others/well.png'),
      pipeImg: require('@/assets/others/pipe.png'),
      standardLists: [],
      tabList: [{
        name: '水质',
        st: 21,
        iconfont: 'icon-shuizhijiance'
      }, {
        name: '空气',
        st: 22,
        iconfont: 'icon-app_icons--'
      }],
      tagList: [{
        name: '卫星',
        st: 1
      }, {
        name: '路网',
        st: 2
      }, {
        name: '路况',
        st: 23
      }],
      pipeList: [],
      wellList: [],
      showMapTag: false,
      st: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.initMap();
      }, 500);
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    map && map.destroy();
  },
  created: function created() {
    this.getTypeList(); // this.getSitearr('')
    // this.getPipeSystem()

    this.getManholeCover();
    this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
  },
  methods: {
    getTypeList: function getTypeList() {
      var _this2 = this;

      ajaxGetDictItems('company_type', null).then(function (res) {
        if (res.success) {
          _this2.getSitearr(res.result[0].value);
        }
      });
    },
    selectCompanyType: function selectCompanyType(cType) {
      this.getSitearr(cType); // if(cType){
      //   this.markerList.forEach((item, index) => {
      //     if (item.type == cType) {
      //       item.show = true
      //     }else {
      //       item.show = false
      //     }
      //   })
      // }else{
      //   this.markerList.forEach((item, index) => {
      //       item.show = true
      //   })
      // }
      // this.initMarker()
    },
    searchSite: function searchSite(searchValue) {
      var _this3 = this;

      if (searchValue) {
        this.markerList.some(function (item, index) {
          if (item.companyName.indexOf(searchValue) != -1) {
            _this3.positionSite(item.id);

            return true;
          }
        });
      }
    },
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.show = true;
            item.lines = lines;
            return item;
          });
          that.showLine();
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            item.show = true;
            return item;
          });
          that.showWell();
        }
      });
    },
    // 渲染管网
    showLine: function showLine() {
      this.pipeList.forEach(function (item) {
        if (item.show) {
          item.lines.forEach(function (line) {
            var polyLine = new AMap.Polyline({
              path: line,
              strokeWeight: 5,
              strokeColor: '#55aaff'
            });
            map.add(polyLine);
            var text = new AMap.Marker({
              offset: new AMap.Pixel(10, 10),
              content: "<span style=\"padding: 5px 10px;background-color: #fff;color: #2eabff;border-radius: 5px;word-break: keep-all;white-space: nowrap\">".concat(item.title, "</span>"),
              position: line[0],
              zIndex: 100000
            });
            map.add(text);
          });
        }
      });
    },
    // 渲染井盖
    showWell: function showWell() {
      var _this4 = this;

      this.wellList.forEach(function (item) {
        if (item.show) {
          item.content = "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this4.wellImg, "\" />");
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item.coordinate.split(',')[0], item.coordinate.split(',')[1]),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            offset: new AMap.Pixel(-20, -20),
            content: item.content,
            zIndex: 100000
          });
          marker.on('click', function (data) {});
          map.add(marker);
        }
      });
    },
    drawBounds: function drawBounds(areaId) {
      map.clearMap();
      this.initMarker(); // this.showLine()

      if (areaId) {
        queryAreaInfo(areaId).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapCenter) {
              map.setCenter(JSON.parse(res.result.mapCenter));
            }

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              features.forEach(function (area) {
                var polygon = new AMap.Polygon({
                  // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                  path: area,
                  strokeColor: 'rgb(20,164,173)',
                  strokeWeight: 4,
                  //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  strokeOpacity: 0.5,
                  //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                  fillColor: 'rgba(0,0,0)',
                  //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  fillOpacity: 0.5,
                  zIndex: 99999999
                });
                map.add(polygon);
              });
            }
          }
        });
      } else {
        var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
        areaRoot.forEach(function (item) {
          queryAreaInfo(item).then(function (res) {
            if (res.success) {
              var features = [];

              if (res.result.mapCenter) {
                map.setCenter(res.result.mapCenter);
              }

              if (res.result.mapStructure) {
                var pointList = JSON.parse(res.result.mapStructure).features.split(':');
                features = pointList.map(function (v) {
                  return v.split('-').map(function (item) {
                    return item.split(',');
                  });
                });
              }

              if (features.length > 0) {
                var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
                var inline = features.map(function (area) {
                  return area.map(function (info) {
                    return new AMap.LngLat(info[0], info[1], true);
                  });
                });
                var pathArray = [outer];
                pathArray.push.apply(pathArray, inline);
                var polygon = new AMap.Polygon({
                  // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                  pathL: pathArray,
                  //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                  strokeColor: 'rgb(20,164,173)',
                  strokeWeight: 4,
                  //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  strokeOpacity: 0.5,
                  //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                  fillColor: 'rgba(0,0,0)',
                  //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  fillOpacity: 0.5,
                  zIndex: 99999999
                });
                polygon.setPath(pathArray);
                map.add(polygon);
              }
            }
          });
        });
      }
    },
    close: function close(state) {
      console.log('state', state);
      this.showContent = state;
    },
    submit: function submit() {
      if (this.state) {
        map.setZoom(14);
        map.setCenter(this.location);
      } else {
        placeSearch.setCity(this.adcode);
        placeSearch.search(this.adname);
      }
    },
    ontoClear: function ontoClear() {
      this.showClose = false;
      mouseTool.close(true);
    },
    ontoClose: function ontoClose() {
      this.showClose = false;
      mouseTool.close();
    },
    ontoMesure: function ontoMesure() {
      this.showState = true;
      this.showClose = true;
      mouseTool.rule({
        startMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/start.png'
          })
        },
        endMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/end.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        midMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/mid.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        lineOptions: {
          //可缺省
          strokeStyle: 'solid',
          strokeColor: '#FF33FF',
          strokeOpacity: 1,
          strokeWeight: 2
        } //同 RangingTool 的 自定义 设置，缺省为默认样式

      });
    },
    ontoArea: function ontoArea() {
      this.showState = false;
      this.showClose = true;
      mouseTool.measureArea({
        strokeColor: '#80d8ff',
        fillColor: '#80d8ff',
        fillOpacity: 0.3 //同 Polygon 的 Option 设置

      });
    },
    onShowleft: function onShowleft() {
      var _this5 = this;

      this.showLeft = !this.showLeft;
      setTimeout(function () {
        _this5.showDrawer = !_this5.showDrawer;
      }, 500);
    },
    onShowright: function onShowright() {
      var _this6 = this;

      this.showTab = !this.showTab;
      setTimeout(function () {
        _this6.showContens = !_this6.showContens;
      }, 500);
    },
    // 点击地图下对应的图标
    Ontoselectwater: function Ontoselectwater(index, index1, obj) {
      var _this7 = this;

      if (index == this.standList.length) {
        this.markerList.forEach(function (item, index2) {
          if (!item.currentStandard) {
            if (item.show) _this7.arr[index2].hide();else _this7.arr[index2].show();
            item.show = !item.show;
          }

          return item;
        });
      } else {
        this.standList[index].children[index1].statu = !this.standList[index].children[index1].statu;
        this.markerList.forEach(function (item, index2) {
          if (item.currentStandard) {
            if (item.currentStandard.title == obj.data.title && item.currentStandard.id == obj.data.id) {
              if (item.show) _this7.arr[index2].hide();else _this7.arr[index2].show();
              item.show = !item.show;
            }

            return item;
          }
        });
      }
    },
    turnTosite: function turnTosite(data) {
      this.$emit('siteTurn', true);
    },
    // 获取站点数据
    getSitearr: function getSitearr() {
      var _this8 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.markerList = [];
      siteCompanyList({
        type: type,
        size: -1
      }).then(function (res) {
        if (res.success) {
          _this8.handleSiteData(res.result.records);
        }
      });
    },
    handleSiteData: function handleSiteData(markerList) {
      var that = this;
      markerList.forEach(function (item, index) {
        if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude];else item.position = ['118.04792', '24.61334'];
        item.show = true;
        item.title = item.companyName;
        item.content = "<div style='position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background: #1e9fff;color: #fff;display: flex;justify-content: center;align-items: center;'><img style=\"width: 20px;height: 15px;\" src='".concat(companyImg, "' /></div>");
        return item;
      });
      this.markerList = markerList;
      this.initMarker();
    },
    ontoTurn: function ontoTurn() {
      map.addControl(new AMap.MapType({
        defaultType: 1,
        //0代表默认，1代表卫星
        showTraffic: true
      }));
    },
    getCompanyDetail: function getCompanyDetail(item) {
      var _this9 = this;

      this.$nextTick(function () {
        _this9.$refs.companyDetail.companyDetail = item;
        _this9.$refs.companyDetail.companyId = item.id;
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    initMarker: function initMarker() {
      var _this10 = this;

      var arr = [];
      map.remove(this.arr);
      map.remove(this.infoWindows);
      this.infoWindows = [];
      this.arr = [];
      this.markerList.forEach(function (item, index) {
        if (item.longitude && item.latitude && item.show) {
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.title,
            offset: new AMap.Pixel(-20, -20),
            content: item.content,
            visible: item.show,
            zIndex: item.zIndex
          });

          if (_this10.showMarkerLabel) {
            marker.setLabel({
              content: item.title,
              direction: 'bottom',
              offset: new AMap.Pixel(0, 10)
            });
          }

          marker.on('click', function (data) {
            _this10.showContent = false;

            _this10.$nextTick(function () {
              _this10.showContent = true;

              _this10.$nextTick(function () {
                clearInterval(_this10.timer);

                _this10.getCompanyDetail(item);

                _this10.positionSite(item.id);
              });
            });
          });
          arr.push(marker);
          map.add(marker);
        }
      });
      this.arr = arr;

      if (this.$route.query.companyId) {
        this.positionSite(this.$route.query.companyId);
      }
    },
    initMap: function initMap() {
      var that = this;
      map = new AMap.Map('container', {
        center: that.center,
        // zoom: that.zoom,
        mapStyle: 'amap://styles/darkblue',
        // 极夜蓝
        pitch: 55,
        // zooms: [3, 15],
        buildingAnimation: true,
        viewMode: '3D'
      });
      map.setZoom(that.zoom);
      map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], function () {
        var autoOptions = {
          datatype: 'all',
          input: 'keyword' //使用联想输入的input的id

        };
        var autocomplete = new AMap.Autocomplete(autoOptions);
        placeSearch = new AMap.PlaceSearch({
          map: map,
          pageSize: 1,
          extensions: 'all'
        });
        AMap.event.addListener(autocomplete, 'select', function (e) {
          //TODO 针对选中的poi实现自己的功能
          if (e.poi.location.lng != undefined) {
            map.setZoom(14);
            map.setCenter(new AMap.LngLat(e.poi.location.lng, e.poi.location.lat));
            that.state = true;
            that.location = new AMap.LngLat(e.poi.location.lng, e.poi.location.lat);
          } else {
            that.state = false;
            that.adcode = e.poi.adcode;
            that.adname = e.poi.name;
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          }
        });
      });
      map.plugin(['AMap.MapType', 'AMap.MouseTool', 'AMap.ControlBar'], function () {
        //地图类型切换
        var type = new AMap.MapType({
          defaultType: 1 //使用2D地图

        });
        mouseTool = new AMap.MouseTool(map);
        map.addControl(type);
        map.addControl(new AMap.ControlBar({
          position: {
            bottom: '-20%',
            right: '20px'
          }
        }));
      });
      map.plugin(['AMap.RangingTool'], function () {
        rangingTool = new AMap.RangingTool(map);
        AMap.event.addListener(rangingTool, 'end', function (e) {
          rangingTool.turnOff();
        });
      }); // 添加叠加图层

      setMapTile(map);
      this.drawBounds();
    },
    positionSite: function positionSite(id) {
      var _this11 = this;

      this.markerList.some(function (v, i) {
        if (v.id == id) {
          _this11.center = v.position;
          _this11.zoom = 14;

          if (v.position[0] && v.position[1]) {
            map.setCenter(new AMap.LngLat(v.position[0], v.position[1]));
          }

          map.setZoom(14);
          _this11.showContent = false;

          _this11.$nextTick(function () {
            _this11.showContent = true;

            _this11.$nextTick(function () {
              clearInterval(_this11.timer);
              _this11.$refs.companyDetail.selectType = v.st;

              _this11.getCompanyDetail(v);
            });
          });

          return true;
        }
      });
    }
  }
};